import styled from 'styled-components';
import { LargeP } from '../../style/typography';
import { colors } from '../../style/colors';
import { min, max } from '../../lib/responsive';

const ConferenceBlurb = styled(LargeP)`
  color: ${colors.WHITE};
  padding-top: 10rem;
  @media ${min.tabletSm} {
    padding-top: 13rem;
  }
  @media ${min.tablet} {
    padding-top: 15rem;
  }
  @media ${min.tabletLg} {
    width: 40rem;
    padding-top: 17rem;
    position: absolute;
  }
  @media ${min.desktop} {
    width: 50rem;
  }
`;

const BlurbContainer = styled.div`
  background-color: ${colors.GRAY};
  height: 65rem;
  overflow: hidden;
  position: relative;
  margin-top: -5rem;
  @media ${min.tabletSm} {
    margin-top: -10rem;
  }
`;

const Frame = styled.img`
  float: right;
  height: 100%;
  z-index: 1;
  display: none;
  @media ${min.tabletLg} {
    display: block;
  }
`;

const BlurbMic = styled.img`
  z-index: 1;
  position: absolute;
  bottom: 0;
  right: 2rem;
  width: 40%;

  @media ${min.tablet} {
    width: 20%;
  }

  @media ${min.tabletLg} {
    width: 30%;
  }

  @media ${min.desktop} {
    right: 7rem;
  }
`;

const MobileFrame = styled.img`
  display: block;
  margin-top: 4rem;
  width: 100%;
  margin-top: 12rem;

  @media ${min.tabletSm} {
    margin-top: 14rem;
  }
  @media ${min.tablet} {
    margin-top: 5rem;
  }

  @media ${min.tabletLg} {
    display: none;
  }
`;

export { ConferenceBlurb, BlurbContainer, Frame, BlurbMic, MobileFrame };
